// SearchBox — champ de recherche avec debounce intégré et bouton clear
import React, { useState, useEffect } from 'react';
import { Search, X } from 'lucide-react';

const SearchBox = ({
  value: controlledValue,
  onChange,
  debounce = 300,
  placeholder = 'Rechercher...',
  ariaLabel = 'Rechercher',
  size = 'md',
  className = '',
}) => {
  const [localValue, setLocalValue] = useState(controlledValue || '');

  // Sync si valeur contrôlée change de l'extérieur (ex. reset)
  useEffect(() => {
    if (controlledValue !== undefined && controlledValue !== localValue) {
      setLocalValue(controlledValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controlledValue]);

  // Debounce : appelle onChange après "debounce" ms d'inactivité
  useEffect(() => {
    if (!onChange) return;
    const t = setTimeout(() => {
      onChange(localValue);
    }, debounce);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localValue, debounce]);

  const sizeClasses = {
    sm: 'h-9 text-sm pl-9 pr-9',
    md: 'h-10 text-sm pl-10 pr-10',
    lg: 'h-12 text-base pl-12 pr-12',
  }[size] || 'h-10 text-sm pl-10 pr-10';

  const iconSize = size === 'sm' ? 'w-4 h-4' : size === 'lg' ? 'w-5 h-5' : 'w-4 h-4';
  const iconLeft = size === 'sm' ? 'left-2.5' : size === 'lg' ? 'left-4' : 'left-3';
  const iconRight = size === 'sm' ? 'right-2.5' : size === 'lg' ? 'right-4' : 'right-3';

  return (
    <div className={`relative ${className}`}>
      <Search
        className={`absolute ${iconLeft} top-1/2 -translate-y-1/2 ${iconSize} text-text-muted pointer-events-none`}
        aria-hidden="true"
      />
      <input
        type="search"
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className={`w-full ${sizeClasses} bg-elevated-2 border border-border-subtle rounded-lg text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition`}
      />
      {localValue && (
        <button
          type="button"
          onClick={() => setLocalValue('')}
          aria-label="Effacer la recherche"
          className={`absolute ${iconRight} top-1/2 -translate-y-1/2 p-1 text-text-muted hover:text-text-primary rounded-full hover:bg-elevated-1 transition`}
        >
          <X className={iconSize} aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default SearchBox;
